// src/auth/RequireAdminAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAdminScopeInfo, isAdminPortalRole } from "./adminSession";

/**
 * Guard tunggal untuk seluruh portal admin.
 * Role dan lokasi dibaca dari getAdminScopeInfo() agar konsisten dengan
 * effective_role, akun lama, serta scope lokasi yang dipakai adminApiScoped.
 */
export default function RequireAdminAuth({ children }) {
  const location = useLocation();
  const scope = getAdminScopeInfo();
  const authed = Boolean(scope.token) && isAdminPortalRole(scope.role);

  if (!authed) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location, reason: "admin-auth" }}
      />
    );
  }

  return children;
}
